<div class="container mt-4">
  <div class="row">
    <!-- Added custom-position to control placement -->
    <div class="col-md-3 custom-position">
      <div class="card section-card h-100 mt-3">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-chart-line section-icon"></i>
            <h3 class="section-title mb-0 ms-2">Market Study</h3>
          </div>

          <!-- Links -->
          <ul class="list-unstyled ms-4">
            <li class="mb-2">
              <a [routerLink]="['/admin/market-study-decorative']"
                 class="text-decoration-none link-style">
                Decorative Coatings
              </a>
            </li>
            <li class="mb-2">
              <a [routerLink]="['/admin/market-study-others']"
                 class="text-decoration-none link-style">
                Others
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
